module.exports = __webpack_public_path__ + "static/cover-7bec2d52b0542b95c0c72d2cb2697d2e.webp";